import PersonaOfficeShell from "@/components/PersonaOfficeShell";
import {
  Tv, Globe, IdCard, Film, TrendingUp, Users, Search,
} from "lucide-react";

/** L5 · Studio · Network · Streamer dashboard.
 *  Broadcasters, TV channels, streaming platforms, major studios. */
const CONFIG = {
  layer:            "L5",
  label:            "Studio · Network · Streamer",
  testidPrefix:     "network-office",
  accent:           "#0EA5E9",
  Icon:             Tv,
  expectedOrgType:  "studio_network",
  blurb:            "Manage macro slates, IP inventory and distribution timelines across every window.",
  tiles: [
    {
      key: "slates", TileIcon: Film,
      title: "Slate Manager",
      desc:  "Every film, series and format in development, production or delivery.",
      chip: "Soon", chipTone: "soon",
    },
    {
      key: "distribution", TileIcon: TrendingUp,
      title: "Distribution Timeline",
      desc:  "Windowed release plan — theatrical → streaming → syndication.",
      chip: "Soon", chipTone: "soon",
    },
    {
      key: "production-houses", to: "/directory/orgs?type=production_house", TileIcon: Search,
      title: "Production Houses",
      desc:  "Every verified production house on Call·Sheet — pitch, commission, greenlight.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "crew", to: "/directory", TileIcon: Users,
      title: "Crew Directory",
      desc:  "Search verified above-the-line and technical crew across India.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "public-profile", to: "/office/public-profile", TileIcon: Globe,
      title: "Public Profile",
      desc:  "Your network's public page — shows, awards, upcoming premieres.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "icard", to: "/icard", TileIcon: IdCard,
      title: "Owner iCard",
      desc:  "Your verified, co-branded identity card.",
      chip: "Live", chipTone: "live",
    },
  ],
};

export default function StudioNetworkDashboard() {
  return <PersonaOfficeShell config={CONFIG} />;
}
